import { defineComponent as _defineComponent } from 'vue'

import { useLightbox } from "@/services/lightbox";
import {faPlay, IconDefinition} from "@fortawesome/free-solid-svg-icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoGallery',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
  items: {
    name: string
    src: string
  }[];
}



const playBtn: IconDefinition = faPlay
const { showGallery } = useLightbox();

function handleClick(index: number) {
  showGallery(props.items.map(i => i.src), index);
}

return { __sfc: true,props, playBtn, showGallery, handleClick }
}

})